import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconExpandLessSvg } from "./IconExpandLessSvg.mjs";
const IconExpandLess = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconExpandLessSvg, ...iconProps });
};
export {
  IconExpandLess
};
